import { AddressInterface } from 'common/address.interface';
import { LineInterface, LineStopInterface } from 'store/ducks/lines/types';

/*
 * Action Types
 */
export enum StopsTypes {
  LIST_STOPS_REQUEST = '@stops/LIST_STOPS_REQUEST',
  LIST_STOPS_SUCCESS = '@stops/LIST_STOPS_SUCCESS',
  LIST_STOPS_FAILURE = '@stops/LIST_STOPS_FAILURE',

  LIST_STOPS_FULL_REQUEST = '@stops/LIST_STOPS_FULL_REQUEST',
  LIST_STOPS_FULL_SUCCESS = '@stops/LIST_STOPS_FULL_SUCCESS',
  LIST_STOPS_FULL_FAILURE = '@stops/LIST_STOPS_FULL_FAILURE',

  LIST_ITINERARY_STOPS_REQUEST = '@stops/LIST_ITINERARY_STOPS_REQUEST',
  LIST_ITINERARY_STOPS_SUCCESS = '@stops/LIST_ITINERARY_STOPS_SUCCESS',
  LIST_ITINERARY_STOPS_FAILURE = '@stops/LIST_ITINERARY_STOPS_FAILURE',

  FILTER_STOPS_REQUEST = '@stops/FILTER_STOPS_REQUEST',
  FILTER_STOPS_SUCCESS = '@stops/FILTER_STOPS_SUCCESS',
  FILTER_STOPS_FAILURE = '@stops/FILTER_STOPS_FAILURE',

  GET_STOP_REQUEST = '@stops/GET_STOP_REQUEST',
  GET_STOP_SUCCESS = '@stops/GET_STOP_SUCCESS',
  GET_STOP_FAILURE = '@stops/GET_STOP_FAILURE',

  GET_STOP_REPORTS_REQUEST = '@stops/GET_STOP_REPORTS_REQUEST',
  GET_STOP_REPORTS_SUCCESS = '@stops/GET_STOP_REPORTS_SUCCESS',
  GET_STOP_REPORTS_FAILURE = '@stops/GET_STOP_REPORTS_FAILURE',

  CREATE_STOP_REQUEST = '@stops/CREATE_STOP_REQUEST',
  CREATE_STOP_SUCCESS = '@stops/CREATE_STOP_SUCCESS',
  CREATE_STOP_FAILURE = '@stops/CREATE_STOP_FAILURE',

  UPDATE_STOP_REQUEST = '@stops/UPDATE_STOP_REQUEST',
  UPDATE_STOP_SUCCESS = '@stops/UPDATE_STOP_SUCCESS',
  UPDATE_STOP_FAILURE = '@stops/UPDATE_STOP_FAILURE',

  DELETE_STOP_REQUEST = '@stops/DELETE_STOP_REQUEST',
  DELETE_STOP_SUCCESS = '@stops/DELETE_STOP_SUCCESS',
  DELETE_STOP_FAILURE = '@stops/DELETE_STOP_FAILURE',

  CREATE_CHIPS_LIST = '@stops/CREATE_CHIPS_LIST',
  CLEAN_CHIPS_LIST = '@stops/CLEAN_CHIPS_LIST',

  SET_SELECTED_START_DATE = '@stops/SELECTED_START_DATE',
  SET_SELECTED_END_DATE = '@stops/SELECTED_END_DATE',
}

/*
 * Data types
 */
export interface TollInterface {
  id: string;
  name: string;
  value: number;
  stopId: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
}

export interface TerminalInterface {
  id: string;
  name: string;
  schedules: string; // json
  bounds: string; // json
  elevators: string;
  escalators: string;
  stairs: string;
  accessRamps: string;
  tactileFloor: string;
  publicToilets: string;
  suggestionBox: string;
  sink: string;
  accessibleSink: string;
  integrationStation: string;
  wifi: string;
  foodCourt: string;
  bikeStation: string;
  bikeRack: string;
  stopId: string;
  createdAt: string;
  updatedAt: string;
  crashEvents: string;
  transportOperatorId: string;
}

export interface StopInterface {
  id: string;
  name: string;
  pronunciation?: string | null;
  startLat: number;
  startLong: number;
  endLat: number;
  endLong: number;
  covered: boolean;
  visible?: boolean;
  busBay: boolean;
  specialBusStop: boolean;
  radius: number;
  type: number;
  addressId: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  Address?: AddressInterface;
  Toll?: TollInterface;
  Terminal?: TerminalInterface;
  Lines?: Array<LineInterface>;
  LineStop?: LineStopInterface;
  LineStops?: LineStopInterface[];
}

export interface StopReportsInterface {
  usedAt: string;
  line: string;
  type: number;
  lineColor: string;
}

export interface ChipsInterface {
  key: number;
  label: string;
  filter: object;
}

/*
 * State type
 */
export interface StopsState {
  readonly stopsList: StopInterface[];
  readonly stopsListFull: StopInterface[];
  readonly itineraryStopsList: StopInterface[];
  readonly stopData: StopInterface;
  readonly stopCreated: StopInterface;
  readonly stopReports: StopReportsInterface[];
  readonly chipsList: ChipsInterface[];
  readonly selectedStartDate: Date;
  readonly selectedEndDate: Date;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
